import React from 'react';
import { Button, styled } from "@mui/material";
const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "customColor",
  name: "Button",
})<{ customColor?: string; theme?: any }>(
  ({ customColor = "white", theme }) => ({
    color: theme.palette.common[customColor],
    border: `1px solid ${theme.palette.common[customColor]}`,
    backdropFilter: `blur(2px)`,
    backgroundColor: "rgba(255, 255, 255, 0.25)",
    "&:hover , &:active": {
      backgroundColor: "rgba(255, 255, 255, 0.25)",
      borderColor: theme.palette.common[customColor],
    },
    "&:focus": {
      boxShadow: "5px 5px 50px rgba(0, 0, 0, 0.25)",
    },
  })
);
export interface GradientButtonInterface {
  color?: string;
  label?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}
const GradientButton = ({ color, label, onClick }: GradientButtonInterface) => {
  return (
    <StyledButton customColor={color} onClick={onClick}>
      {label}
    </StyledButton>
  );
};

export default GradientButton;
